import { render, staticRenderFns } from "./TsgForm.vue?vue&type=template&id=dd8f4b34&scoped=true&"
import script from "./TsgForm.vue?vue&type=script&lang=js&"
export * from "./TsgForm.vue?vue&type=script&lang=js&"
import style0 from "./TsgForm.vue?vue&type=style&index=0&id=dd8f4b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8f4b34",
  null
  
)

export default component.exports